import {itemWithoutAdditionalRibbons} from './itemWithoutAdditionalRibbons';

export const query = `query getSliderGalleryDataWithoutAdditionalRibbons($externalId: String!, $compId: String!, $limit: Int!, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
  appSettings(externalId: $externalId) {
    widgetSettings
  }
  catalog {
    isCatalogV3
    category(compId: $compId) {
      id
      name
      visible
      productsWithMetaData(limit: $limit, onlyVisible: true) {
        list {
          ${itemWithoutAdditionalRibbons}
        }
        totalCount
      }
    }
    allProductsCategoryId
  }
}
`;
